import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { Media } from '../_model/media';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-imageInput',
    templateUrl: './imageInput.component.html',
    styleUrls: ['./imageInput.component.less'],
    standalone: false
})
export class ImageInputComponent implements OnInit, OnChanges {

  faTrash = faTrash;

  constructor(private sanatizer: DomSanitizer,private http: HttpClient) { }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.models?.currentValue && this.multiple) {
      this.image = [];
      this.models = changes.models.currentValue;
      setTimeout(() => {
        this.image = [];
        this.models.forEach((it: Media) => {
          this.image.push(this.sanatizer.bypassSecurityTrustUrl("data:image/"+it.name.split(".")[it.name.split(".").length-1]+";base64,"+(this.isBase64(it.file) ? it.file : btoa(this.Uint8ArrayToString(it.file)))));
        });
      }, 400);
    }else if(changes?.model?.currentValue && !this.multiple) {
      this.image = [];
      this.model = changes.model.currentValue;
      setTimeout(() => {
        this.image = [];
        this.image.push(this.sanatizer.bypassSecurityTrustUrl("data:image/"+this.model.name.split(".")[this.model.name.split(".").length-1]+";base64,"+(this.isBase64(this.model.file) ? this.model.file : btoa(this.Uint8ArrayToString(this.model.file)))));
      }, 400);
    }else if(!changes?.model?.currentValue && ! this.multiple) {
      this.image = [];
    }
  }

  @Input() models: Media[] = [];
  @Input() model: Media = new Media();
  @Input() displayOutput: Boolean = true;

  image: any[] = [];
  @Input() titulo: string = "titulo";
  @Input() btn: string = "Botao";
  @Input() multiple: boolean = false;
  @Output() modelsChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() modelChange: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
  }

  remove(i: number) {
    this.image.splice(i,1);
    this.models.splice(i,1);
  }

  onMultipleFileChange(ev) {
    for(var j = 0; j<ev.target.files.length && j<8; j++) {
      if(ev.target.files[j].size < 8388608) {
        this.models.push(this.readFromUrl(ev.target.files[j],ev.target.files[j].name));
      }else {
        Swal.fire({
          title: 'Erro de carregamento!',
          text: 'O tamanho máximo suportado pelo servidor media para imagens é de 8Mb.',
          icon: 'warning',
          customClass: {
            confirmButton: "btn harvest-gold base",
            popup: "backgroundColor star-dust darken-4",
            title: "textColor white base",
            htmlContainer: "textColor white base"
          }
        });
      }
    }

    if(this.models.length > 8) {
      Swal.fire({
        title: 'O carregamento de imagens ultrapassa o valor limite suportado!',
        text: 'O Carousel só pode conter oito imagens.',
        icon: 'warning',
        customClass: {
          confirmButton: "btn harvest-gold base",
          popup: "backgroundColor star-dust darken-4",
          title: "textColor white base",
          htmlContainer: "textColor white base"
        }
      });
      while(this.models.length > 8) {
        this.models.pop();
      }
    }
    this.image = [];
    setTimeout(() => {
      this.models.forEach((it: Media) => {
        this.image.push(this.sanatizer.bypassSecurityTrustUrl("data:image/"+it.name.split(".")[it.name.split(".").length-1]+";base64,"+(this.isBase64(it.file) ? it.file : btoa(this.Uint8ArrayToString(it.file)))));
      });
      this.modelsChange.emit(this.models);
    },1000);
  }

  onfileChangeDecider(ev) {
    if(this.multiple) {
      this.onMultipleFileChange(ev);
    }else {
      this.onSingleFileChange(ev);
    }
  }

  onSingleFileChange(ev) {
    var reader = new FileReader();
    reader.readAsArrayBuffer(ev.target.files[0]);
    this.image = [];
    this.model.file = [];
    reader.onloadend = (e) => {
      if(e.target.readyState == FileReader.DONE) {
        var arrayBuffer: ArrayBuffer = (<ArrayBuffer> e.target.result);
        var array: Uint8Array = new Uint8Array(arrayBuffer);
        for(var i = 0; i < array.length; i++ ) {
          this.model.file.push(array[i]);
        }
        this.image.push(this.sanatizer.bypassSecurityTrustUrl("data:image/"+this.model.name.split(".")[this.model.name.split(".").length-1]+";base64,"+(this.isBase64(this.model.file) ? this.model.file : btoa(this.Uint8ArrayToString(this.model.file)))));
      }
    };
    this.model.name = ev.target.files[0].name;
    this.modelChange.emit(this.model);
  }
  isBase64(str: any) {
    var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    return base64regex.test(str);
  }
  Uint8ArrayToString(dataI: any) {
    var data = new Uint8Array(dataI);
    var CHUNK_SZ = 0x8000;
    var c = [];
    for (var i=0; i < data.length; i+=CHUNK_SZ) {
      c.push(String.fromCharCode.apply(null, data.subarray(i, i+CHUNK_SZ)));
    }
    return c.join("");
  }
  sendUrl(file: Media) {
    return this.sanatizer.bypassSecurityTrustUrl("data:image/"+file.name.split(".")[file.name.split(".").length-1]+";base64,"+(this.isBase64(file.file) ? file.file : btoa(this.Uint8ArrayToString(file.file))));
  }
  readFromUrl(data, name): Media {
    var reader = new FileReader();
    var result = new Media();
    reader.readAsArrayBuffer(data);
    reader.onloadend = (e) => {
      if(e.target.readyState == FileReader.DONE) {
        var arrayBuffer: ArrayBuffer = (<ArrayBuffer> e.target.result);
        var array: Uint8Array = new Uint8Array(arrayBuffer);
        for(var i = 0; i < array.length; i++ ) {
          result.file.push(array[i]);
        }
      }
    };
    result.name = name;
    return result;
  }

}